export const UNAVAILABLE = 'unavailable';
export const INELIGIBLE = 'ineligible';
export const AVAILABLE = 'available';
export const ACTIVE = 'active';
export const PENDING = 'pending';
export const CANCELED = 'canceled';

type IsStatus = (status: EnrollmentStatus) => boolean;

export const isUnavailable: IsStatus = status => status === UNAVAILABLE;
export const isIneligible: IsStatus = status => status === INELIGIBLE;
export const isAvailable: IsStatus = status => status === AVAILABLE;
export const isActive: IsStatus = status => status === ACTIVE;
export const isPending: IsStatus = status => status === PENDING;
export const isCanceled: IsStatus = status => status === CANCELED;
